import { combineReducers } from '@reduxjs/toolkit';

import { RootState } from '../../../store';

import composeSlice from './composeSlice';
import inboxSlice from './inboxSlice';

const messagesReducer = combineReducers({
  compose: composeSlice,
  inbox: inboxSlice,
});

export const selectMessagesState = (state: RootState) => state.messages;

export default messagesReducer;
